var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"childbox relative"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v("当"+_vm._s(_vm.dateType1)+"用电费用")])]),_c('div',{staticClass:"chart_box3"},[_c('div',{staticClass:"box",attrs:{"id":_vm.echartsId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }